<template>
  <div>
    <form @submit.prevent="handleLogin" class="block sign_in landscape:mx-auto">
      <!-- sign in form  -->
      <div
        class="w-full bg-white landscape:p-3 md:rounded-l-0 rounded-l-lg rounded-r-lg flex items-center justify-center text-gray-950 text-center relative"
      >
        <div class="w-full max-w-md">
          <div class="mb-5">
            <div class="mb-5 flex items-center justify-center">
              <a href=".away/" title="Hisell Technology">
                <img src="/logo2.png" width="95px" height="15px" />
              </a>
            </div>
            <div class="text-2xl font-medium mb-2 text-gray-800">
              Welcome back
            </div>
            <div class="block text-sm px-5 mb-2 font-normal text-gray-600">
              Enter your credentials to access your account or log in with
              Google.
            </div>
          </div>
          <p :class="messageClass">{{ message }}</p>
          <div class="mb-[40px]">
            <div class="relative mb-2">
              <input
                type="email"
                id="useremail"
                name="useremail"
                v-model="useremail"
                title="Enter your Email"
                :disabled="loading"
                required
                class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-950 bg-transparent border border-t-0 border-r-0 border-l-0 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-800 peer"
                placeholder=""
              />
              <label
                for="useremail"
                class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-800 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >E-mail address</label
              >
              <span
                class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-400"
              >
                <i class="fa-solid fa-at"></i>
              </span>
            </div>
            <div class="relative mb-2">
              <input
                :type="showPassword ? 'text' : 'password'"
                id="userpassword"
                name="userpassword"
                title="Enter your password"
                v-model="userpassword"
                :disabled="loading"
                required
                class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-950 bg-transparent border border-t-0 border-r-0 border-l-0 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-600 peer"
                placeholder=""
              />
              <label
                for="userpassword"
                class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >Password</label
              >
              <div
                class="absolute top-1/2 right-2 -translate-y-1/2 flex items-center space-x-2"
              >
                <button
                  type="button"
                  @click="showPassword = !showPassword"
                  class="text-gray-400 hover:text-gray-600 focus:outline-none"
                  :aria-label="showPassword ? 'Hide password' : 'Show password'"
                >
                  <i
                    :class="
                      showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'
                    "
                  ></i>
                </button>
                <i class="fa-solid fa-lock text-gray-400"></i>
              </div>
            </div>

            <div class="flex items-center justify-between mt-4">
              <div class="inline-flex items-center">
                <label
                  class="relative flex items-center p-1 rounded-full cursor-pointer"
                  htmlFor="rememberme"
                  title="You will be remembered for the next 24 hours"
                >
                  <input
                    type="checkbox"
                    name="rememberme"
                    :disabled="loading"
                    v-model="rememberme"
                    class="before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-button checked:bg-button checked:before:bg-button hover:before:opacity-10"
                    id="rememberme"
                  />
                  <span
                    class="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
                <label
                  class="mt-px font-light text-button cursor-pointer select-none"
                  htmlFor="rememberme"
                >
                  <div>
                    <p
                      class="block text-xs antialiased font-medium leading-relaxed text-gray-500"
                      title="You will be remembered for the next 24 hours"
                    >
                      Remember Me
                    </p>
                  </div>
                </label>
              </div>
              <div class="text-xs text-linkbutton font-medium">
                <router-link to="/reset">Forgot Password</router-link>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <button
              type="submit"
              class="align-middle select-none font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-sm py-3.5 px-7 rounded-lg text-white shadow-md shadow-button/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none block w-full bg-button p-2"
            >
              <span
                class="flex flex-row justify-center items-center"
                v-if="loading"
              >
                <svg
                  class="h-5 w-5 mr-3 animate-spin text-gray-50"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                >
                  <path
                    d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                    stroke="currentColor"
                    stroke-width="5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                    stroke="currentColor"
                    stroke-width="5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="text-gray-900"
                  ></path>
                </svg>
                Logging in...
              </span>
              <span v-else>Login</span>
            </button>
          </div>
          <div
            class="flex items-center w-full uppercase text-xs font-medium mb-3 text-gray-600"
          >
            <div class="flex-1 border-b border-gray-300 h-2"></div>
            <span class="px-2">Or</span>
            <div class="flex-1 border-b border-gray-300 h-2"></div>
          </div>
        </div>
      </div>
      <div class="mb-5 w-full max-w-md mx-auto">
        <button
          @click="handleGoogleLogin"
          class="align-middle select-none font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-sm py-3.5 px-7 rounded-lg border text-gray-600 hover:opacity-75 focus:ring focus:ring-gray-300 active:opacity-[0.85] w-full flex h-12 border-gray-200 items-center justify-center gap-2"
          type="button"
          data-ripple-dark="true"
        >
          <img
            src="/logo-google.png"
            alt="google"
            :class="{
              'border-blue-600 rounded-full animate-spin': googleLoading,
            }"
            class="h-6 w-6"
          />
          <span v-if="!googleLoading">sign in with google</span>
          <span v-else>Processing...</span>
        </button>
      </div>
      <div
        variant="small"
        color="gray"
        class="!mt-4 text-center font-normal text-base text-gray-500"
      >
        New to us?
        <router-link
          to="/register"
          class="font-medium text-gray-700 underline underline-offset-2"
        >
          Create account
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { GoogleSignInMod } from "@/utils/authutils";
export default {
  name: "LoginComponent",
  data() {
    return {
      useremail: "",
      userpassword: "",
      rememberme: false,
      message: "",
      messageClass: "",
      loading: false,
      googleLoading: false,
      showPassword: false,
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("verified")) {
      this.message = "Your account has been verified. You can now log in.";
      this.messageClass = "text-green-500";
    }
    if (urlParams.has("message")) {
      this.message = urlParams.get("message");
      this.messageClass = "text-red-500";
    }
  },
  methods: {
    ...mapActions(["login", "googleLogin"]),
    async handleLogin() {
      this.loading = true;
      this.message = "";
      const userData = {
        email: this.useremail,
        password: this.userpassword,
        rememberme: this.rememberme,
      };

      try {
        const response = await this.login(userData);
        if (response.success) {
          this.message = "Login successful!";
          this.messageClass = "text-green-500";
          const storage = this.rememberme ? localStorage : sessionStorage;
          if (
            response.token !== null ||
            response.token !== "" ||
            response.token !== "undefined"
          ) {
            storage.setItem("authToken", response.token);
          }
          const redirectPath = this.$route.query.redirect || "/";
          this.$router.push(redirectPath);
        } else {
          console.log(response);
          this.message = response.error || "Invalid username or password";
          this.messageClass = "text-red-500";
        }
      } catch (error) {
        console.log(error);
        this.message = error.message || "An error occured during login";
        this.messageClass = "text-red-500";
      } finally {
        this.loading = false;
      }
    },
    async handleGoogleLogin() {
      this.googleLoading = true;
      try {
        const googleResponse = await GoogleSignInMod();
        if (googleResponse) {
          const userData = {
            id_token: googleResponse.id_token,
          };
          const response = await this.googleLogin(userData);
          if (response.success) {
            this.message = "Login successful!";
            this.messageClass = "text-green-500";
            const storage = this.rememberme ? localStorage : sessionStorage;

            if (
              response.token !== null ||
              response.token !== "" ||
              response.token !== "undefined"
            ) {
              storage.setItem("authToken", response.token);
            }
            const redirectPath = this.$route.query.redirect || "/";
            this.$router.push(redirectPath);
          } else {
            this.message =
              response.error ||
              "Google user does not exist! do you wish to signup?";
            this.messageClass = "text-red-500";
          }
          console.log("Handle the response", response);
        } else {
          this.message = "Google sign-in was canceled.";
          this.messageClass = "text-red-500";
        }
      } catch (error) {
        this.message =
          error.message || "An error occurred during Google sign-in.";
        this.messageClass = "text-red-500";
      } finally {
        this.googleLoading = false;
      }
    },
  },
};
</script>
